export default __webpack_public_path__ + "static/media/mainLogo.30c9629d.png";